<template>
  <div>
    <div class="form-group">
      <div class="col-xs-12" style="padding: 0px">
        <div class="input-group">
          <input type="email" name="user[email]" id="user_email" class="form-control input-lg" placeholder ="Correo / Usuario" :required="true" style ="font-size: 20px; background-color: white !important;padding-left: 17px !important">
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12" style="padding: 0px">
        <div class="input-group">
          <input type="password" name="user[password]" id="user_password" class ="form-control input-lg" placeholder="Contraseña" :required ="true" style ="font-size: 20px; background-color: white !important;padding-left: 17px">
        </div>
      </div>
    </div>
    <div v-if="view" class="form-group">
      <div class="col-xs-12">
        <vue-recaptcha id="forTest" :sitekey="'6LcBS_MeAAAAAOJPbF-DH4SaqTLHIDuhh0tiiYE-'" :loadRecaptchaScript="true" @verify="responseVerify"></vue-recaptcha>
      </div>
    </div>
    <div v-if="response && view" class="form-group form-actions">
        <div class="col-xs-12 text-center separator" >
            <button type="submit" id="btnLogin" class="">Ingresar</button>
        </div>
    </div>
    <div v-if="!view" class="form-group form-actions">
        <div class="col-xs-12 text-center separator" >
            <button type="submit" id="btnLogin" class="">Ingresar</button>
        </div>
    </div>
    
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
export default {
  name:'loginComponent',
  data(){
    return {
      response: false,
      view: null
    }
  },
  components:{
    VueRecaptcha
  },
  methods:{
    responseVerify(response){
      console.log("Captcha response", response)
      const path = '/api/v1/validate'
      const data = { response: response }
      axios.post(path,data).then(res => {
        if(res.data.response.success){
          this.response = true
        }else{
          console.log("error validating captcha", res)
        }
      })
    }
  },
  created() {
    // Bypass reCAPTCHA in local development or Cypress
    this.view = window.Cypress != undefined || window.location.hostname === 'localhost' ? false : true
    // Automatically enable login button in local development
    if (window.location.hostname === 'localhost') {
      this.response = true
    }
  }
}
</script>

<style>

</style>
                
               